// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


import {Environment} from './environment.model';

export const environment: Environment = {
	environment: 'stage',
	production: true,
	clientID: 'ba759d58-4bd4-43a7-b0b6-27fd37e96ae5',
	clientSecret: 'uvu83ej0ctckscow0gsw0w8kw0goco0sswc0k8o8og00o4ww0',
	UPLOAD_APIKEY: '1fb9d31b-3581-45d3-8ad1-284bba64dfa0',
	apiKey: '8a77b9d6-e6cc-4d71-87d8-f96c621a1245'
};
